import * as Configuration from 'src/ajs-app/app.constants.js';
import { isActive } from './navigationUtils.js';

NavigationPreferencesController.$inject = ['$scope', 'loggedUser', '$state', 'TopToolbarFactory'];
export function NavigationPreferencesController($scope, loggedUser, $state, TopToolbarFactory) {

  init();
  $scope.setSelectedMenu = setSelectedMenu;

  function setSelectedMenu(mySelectedKey) {
    Object.keys($scope.navigation.preferences).forEach((key) => {
      $scope.navigation.preferences[key].isSelected = `${mySelectedKey}` === `${key}`;
    });
  }

  function init() {
    TopToolbarFactory.setSubNavBurger($scope);
    $scope.loggedUser = loggedUser;
    /* Variables definition */
    $scope.navigation = {
      'preferences': {
        'account': {
          'isSelected': isActive($state, 'preferences.account'),
          'url': `${Configuration.constants.frontendBaseUrl}${$state.href('auth.alcmeon.fuse.preferences.account')}`
        },
        'password': {
          'isSelected': isActive($state, 'preferences.password'),
          'url': `${Configuration.constants.frontendBaseUrl}${$state.href('auth.alcmeon.fuse.preferences.password')}`
        },
        'notifications': {
          'isSelected': isActive($state, 'preferences.notifications'),
          'url': `${Configuration.constants.frontendBaseUrl}${$state.href('auth.alcmeon.fuse.preferences.notifications')}`
        },
        'status-check': {
          'isSelected': isActive($state, 'preferences.status-check'),
          'url': `${Configuration.constants.frontendBaseUrl}${$state.href('auth.alcmeon.fuse.preferences.status-check')}`
        }
      }
    };
  }

}
